export const sendAdobeData = (digitalData?: Record<string, unknown>) => {
  const windowEvent = new CustomEvent('dataLayerUpdated', {
    detail: digitalData
  });
  window.dispatchEvent(windowEvent);

  window._satellite &&
    window._satellite.track &&
    window._satellite.track('new_page_view', digitalData);
};
